module.exports = __webpack_public_path__ + "static/media/ss-2.7724cad3.png";